import './index.scss'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useState, useRef } from 'react'
import emailjs from '@emailjs/browser'
import {
  MapContainer,
  TileLayer,
  //useMap,
  Marker,
  Popup
} from 'react-leaflet'


const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const refForm = useRef()

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_bzvmiv6',
        'contact_form',
        refForm.current,
        'eTYV0QSSCTt8lzkZx'
      )
      .then(
        () => {
          alert('Message successfully sent!')
          window.location.reload(true)
        },
        () => {
          alert('Failed to send the message, please try again')
        }
      )
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            While I am not explicitly seeking any job opportunities, I am open
            to working on small projects with the purpose of learning and
            collaboration. If you need a jack of all trades eager to learn a new
            language, framework or technology, please don't hesitate to contact
            me.
          </p>
          <div className="contact-form">
            <form ref={refForm} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input type="text" name="name" placeholder="Name" required />
                </li>
                <li className="half">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                </li>
              </ul>
            </form>
          </div>
        </div>
          <div className='info-map'>
              Blayne S. Gower II,
              <br />
              Richmond,
              <br/>
              1024 Felling Goodway drive <br />
              Richmond, Va. <br />
              <span>blayne.gower@gmail.com</span>
          </div>
          <div className='map-wrap'>
            <MapContainer center={[37.540726, -77.436050]} zoom={13}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <Marker position={[37.540726, -77.436050]} >
                <Popup> I don't actually live here</Popup>
                </Marker>
              </MapContainer>
          </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
